import { API_BASE_URL } from './utils';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function requestNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (typeof Notification === 'undefined') return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  return Notification.requestPermission();
}

export async function registerWebPush(token: string, resourceId?: string): Promise<boolean> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;

  try {
    const keyRes = await fetch(`${API_BASE_URL}/push/vapid-public-key`);
    const { publicKey } = await keyRes.json();
    if (!publicKey) return false;

    const registration = await navigator.serviceWorker.ready;
    let sub = await registration.pushManager.getSubscription();
    if (!sub) {
      sub = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey) as BufferSource,
      });
    }

    await fetch(`${API_BASE_URL}/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ subscription: sub, resourceId, sessionActive: true }),
    });
    return true;
  } catch {
    return false;
  }
}

export async function unregisterWebPush(token: string | null): Promise<void> {
  if (!token) return;
  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready.catch(() => null);
      const sub = await registration?.pushManager.getSubscription();
      await sub?.unsubscribe();
    }
    await fetch(`${API_BASE_URL}/push/unsubscribe`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch { /* ignore */ }
}

export async function registerNativeDevice(token: string, fcmToken: string, resourceId: string): Promise<void> {
  try {
    await fetch(`${API_BASE_URL}/push/register-device`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ fcmToken, resourceId }),
    });
  } catch { /* ignore */ }
}

export async function unregisterNativeDevice(token: string | null): Promise<void> {
  if (!token) return;
  try {
    await fetch(`${API_BASE_URL}/push/register-device`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch { /* ignore */ }
}
